import React from 'react';
import { CheckMarkContainer, CheckMarkIcon, CheckMarkPanel } from './style';
export const CheckMark = (props) => {
    return props.isSelected ? (React.createElement(CheckMarkContainer, { id: `checkmark-${props.id}` },
        React.createElement(CheckMarkPanel, { id: `checkmark-panel-${props.id}` },
            React.createElement(CheckMarkIcon, { className: "mi-icat-icon mi-icon-complete-filled-circle", id: `checkmark-icon-${props.id}` })))) : (React.createElement(React.Fragment, null));
};
//# sourceMappingURL=CheckMark.js.map